export default "__VITE_ASSET__BnNNmKIe__"